import { identity, uploadImage } from "deso-protocol";

export const uploadInlineImageFile = async (file: File) => {
  const snapshot = await identity.snapshot();

  if (!snapshot?.currentUser) {
    return null;
  }

  const response = await uploadImage(
    {
      file,
      UserPublicKeyBase58Check: snapshot.currentUser.publicKey,
    },
    {
      nodeURI: process.env.NEXT_PUBLIC_CORE_DESO_NODE,
    },
  );

  return response.ImageURL;
};
